// ═══════════════════════════════════════════════════════════════════
//  modules/chat/SujFilterRow.js
//  SujFilterRow
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../../socle/theme";

export function SujFilterRow({ label, children }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
      <span style={{ color: THEME.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: 0.8, textTransform: "uppercase", width: 96, flexShrink: 0 }}>{label}</span>
      <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap", flex: 1 }}>{children}</div>
    </div>
  );
}
